/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Cover_LettersInputs */

const en_pricing_compare_cover_letters = /** @type {(inputs: Pricing_Compare_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover letters`)
};

const de_pricing_compare_cover_letters = /** @type {(inputs: Pricing_Compare_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben`)
};

const fr_pricing_compare_cover_letters = /** @type {(inputs: Pricing_Compare_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettres de motivation`)
};

const es_pricing_compare_cover_letters = /** @type {(inputs: Pricing_Compare_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartas de presentación`)
};

const it_pricing_compare_cover_letters = /** @type {(inputs: Pricing_Compare_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettere di presentazione`)
};

const nl_pricing_compare_cover_letters = /** @type {(inputs: Pricing_Compare_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatiebrieven`)
};

const pl_pricing_compare_cover_letters = /** @type {(inputs: Pricing_Compare_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listy motywacyjne`)
};

const fi_pricing_compare_cover_letters = /** @type {(inputs: Pricing_Compare_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatekirjeet`)
};

const da_pricing_compare_cover_letters = /** @type {(inputs: Pricing_Compare_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsbreve`)
};

const sv_pricing_compare_cover_letters = /** @type {(inputs: Pricing_Compare_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personliga brev`)
};

/**
* | output |
* | --- |
* | "Cover letters" |
*
* @param {Pricing_Compare_Cover_LettersInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_cover_letters = /** @type {((inputs?: Pricing_Compare_Cover_LettersInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Cover_LettersInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_cover_letters(inputs)
	if (locale === "fr") return fr_pricing_compare_cover_letters(inputs)
	if (locale === "es") return es_pricing_compare_cover_letters(inputs)
	if (locale === "it") return it_pricing_compare_cover_letters(inputs)
	if (locale === "nl") return nl_pricing_compare_cover_letters(inputs)
	if (locale === "pl") return pl_pricing_compare_cover_letters(inputs)
	if (locale === "fi") return fi_pricing_compare_cover_letters(inputs)
	if (locale === "da") return da_pricing_compare_cover_letters(inputs)
	if (locale === "sv") return sv_pricing_compare_cover_letters(inputs)
	return en_pricing_compare_cover_letters(inputs)
});